export const current_user_loaded = 'current_user_loaded';
export const logout = 'logout';
export const auth_request = 'auth_request';
export const auth_success = 'auth_success';
export const init_complete = 'init_complete';
export const auth_error = 'auth_error';
export const TOGGLE_DEBUG_TOOLS = 'TOGGLE_DEBUG_TOOLS';